import { render, staticRenderFns } from "./FresherJobs.vue?vue&type=template&id=4d7c9fac&"
import script from "./FresherJobs.vue?vue&type=script&lang=js&"
export * from "./FresherJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports